import { IProductCard } from '@src/components/product-card/product-card.types'
import collectionService from '@src/pages/[...slug]/components/collection/services/collectionService'
import { getProductCardsFromCollection } from '@src/pages/[...slug]/components/collection/services/collectionService/utils'
import productRecommendationService from '@src/quince-site-common/src/services/productRecommendationService'

import {
  getCollectionIdForRecommendations,
  getProductIdForRecommendations,
  getProductSpidForRecommendations,
  getSelectedColor,
  IGetRecommendedProductsApiParams,
  RECOMMENDATION_TYPE_TO_PRODUCT_LIMIT_MAP,
} from '../utils'

export type IGetBoytProductsApiParams = IGetRecommendedProductsApiParams & { nextUrl: string | undefined }
export const getBoytProductsApi = async (
  { product, selectedOptions, nextUrl, isNewPDPRecommendations, recommendedProductsType }: IGetBoytProductsApiParams,
  isI18nPreviewEnabled: boolean,
): Promise<{
  data: IProductCard[]
  nextUrl: string | undefined
}> => {
  const spid = getProductSpidForRecommendations(product, selectedOptions)
  const selectedColor = getSelectedColor(selectedOptions)

  if (!selectedColor) {
    return {
      data: [],
      nextUrl: '',
    }
  }

  if (isNewPDPRecommendations) {
    const collectionId = getCollectionIdForRecommendations(product, recommendedProductsType)
    const collection = await collectionService.getCollectionById(
      {
        collectionId: collectionId,
        limit: RECOMMENDATION_TYPE_TO_PRODUCT_LIMIT_MAP[recommendedProductsType],
        productIdForRecommendations: getProductIdForRecommendations(product),
        colorForProductRecommendations: selectedColor,
        ...(nextUrl && { nextPageUrl: nextUrl }),
      },
      isI18nPreviewEnabled,
    )

    const productCards = getProductCardsFromCollection(collection)
    return {
      data: productCards,
      nextUrl: collection.next_url,
    }
  }

  // if next url

  if (nextUrl) {
    return productRecommendationService.getNextFeedForBYOT(spid as number, nextUrl)
  } else {
    return productRecommendationService.getYouMayAlsoLikeProducts(spid as number, selectedOptions, {
      viewContextGender: product.gender,
      limit: 20,
      useLite: true,
    })
  }
}
